"use client"

import { useEffect, useRef } from "react"

import { useScreenVisible } from "@/platform/app-mode/use-screen-visible"
import { isEnvelopeHostAvailable } from "@/platform/bridge/use-native-bridge"
import { viewerBoundaryGeneration } from "@/platform/session/viewer-boundary"

let identity: number | undefined
const exposures = new Set<string>()

export const useVisibleExposure = (key: string, track: () => void): void => {
  const visible = useScreenVisible()
  const last = useRef<string | null>(null)
  const signature = viewerBoundaryGeneration()
  useEffect(() => {
    if (!visible) return
    const exposure = `${signature}:${key}`
    if (!isEnvelopeHostAvailable()) {
      if (last.current === exposure) return
      last.current = exposure
      track()
      return
    }
    if (identity !== signature) {
      identity = signature
      exposures.clear()
    }
    if (exposures.has(key)) return
    exposures.add(key)
    track()
  }, [signature, key, track, visible])
}
